var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.819,
    height: 13.818,
    viewBox: "0 0 12.819 13.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.951,178.7a1.329,1.329,0,0,0,1.326-1.329v-9.629a1.329,1.329,0,0,0-1.326-1.329h-9.668a1.329,1.329,0,0,0-1.326,1.329v9.629a1.329,1.329,0,0,0,1.326,1.329Zm-10.443-1.329v-9.629a.777.777,0,0,1,.776-.777h9.668a.777.777,0,0,1,.776.777v9.629a.777.777,0,0,1-.776.777h-9.668A.777.777,0,0,1,163.508,177.37Z",
    transform: "translate(-162.958 -166.412)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5,155.334v-2.121a.268.268,0,0,0-.536,0v2.121a.268.268,0,1,0,.536,0Z",
    transform: "translate(-204.963 -152.945)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.943,155.334v-2.121a.268.268,0,0,0-.536,0v2.121a.268.268,0,1,0,.536,0Z",
    transform: "translate(-271.407 -152.945)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.268 3.735)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.725,
    height: 0.536,
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.113 5.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.428,228.028a.319.319,0,1,0-.319.319A.319.319,0,0,0,190.428,228.028Z",
    transform: "translate(-189.791 -227.709)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.589 5.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.878,228.028a.319.319,0,1,0-.319.319A.319.319,0,0,0,221.878,228.028Z",
    transform: "translate(-221.241 -227.709)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.065 5.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.328,228.028a.319.319,0,1,0-.319.319A.319.319,0,0,0,253.328,228.028Z",
    transform: "translate(-252.691 -227.709)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.542 5.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.779,228.028a.319.319,0,1,0-.319.319A.319.319,0,0,0,284.779,228.028Z",
    transform: "translate(-284.142 -227.709)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.113 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.428,256.9a.319.319,0,1,0-.319.319A.319.319,0,0,0,190.428,256.9Z",
    transform: "translate(-189.791 -256.586)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.589 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.878,256.9a.319.319,0,1,0-.319.319A.319.319,0,0,0,221.878,256.9Z",
    transform: "translate(-221.241 -256.586)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.065 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.328,256.9a.319.319,0,1,0-.319.319A.319.319,0,0,0,253.328,256.9Z",
    transform: "translate(-252.691 -256.586)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.542 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.779,256.9a.319.319,0,1,0-.319.319A.319.319,0,0,0,284.779,256.9Z",
    transform: "translate(-284.142 -256.586)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.113 10.433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.428,285.782a.319.319,0,1,0-.319.319A.319.319,0,0,0,190.428,285.782Z",
    transform: "translate(-189.791 -285.463)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.589 10.433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.878,285.782a.319.319,0,1,0-.319.319A.319.319,0,0,0,221.878,285.782Z",
    transform: "translate(-221.241 -285.463)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.065 10.433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.328,285.782a.319.319,0,1,0-.319.319A.319.319,0,0,0,253.328,285.782Z",
    transform: "translate(-252.691 -285.463)",
    fill: "#f6a409",
    stroke: "#f6a409",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3cb550f7.svg";
export { ForwardRef as ReactComponent };